import React from 'react'

import { Form } from 'rsuite'
import FormMaskControl from '@components/common/form/FormMaskControl'

import { PHONE_NUMBER_FORMAT } from '@@partner:config/index'

export interface CustomerPhoneProps extends Record<string, any> {
  label?: string
}

export default function CustomerPhone ({
  label,
  ...restProps
}: CustomerPhoneProps) {
  return (
    <Form.Group>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <FormMaskControl
        placeholder={label}
        mask={PHONE_NUMBER_FORMAT}
        {...restProps}
      />
    </Form.Group>
  )
}
